<template>
  <div>
    <v-text-field
      v-model="search"
      append-icon="mdi-magnify"
      label="Search"
      single-line
      hide-details
    ></v-text-field>
    <v-card v-if="loading">
      <v-card-text>
        <div>Loading</div>
      </v-card-text>
    </v-card>
    <v-layout row v-if="products.length > 0">
      <v-flex xs12 sm12>
        <v-card>
          <v-data-table
            :headers="headers"
            :items="products"
            :loading="loading"
            :pagination.sync="pagination"
            :total-items="totalCount"
          >
            <template v-slot:item.action="props">
              <v-btn icon @click.stop="selectSet(props.item)" color="primary">
                <v-icon small>mdi-check</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import _ from "lodash";
export default {
  data() {
    return {
      search: this.initialSearch,
      products: [],
      pagination: { rowsPerPage: 5 },
      filters: {
      },
      headers: [
        { text: "name", value: "name", sortable: false },
        { text: "Nb item", value: "size", sortable: false },
        { text: "type", value: "classification", sortable: false },
        { text: "dominantHand", value: "dominantHand", sortable: false },
        { text: "", value: "action", sortable: false }
      ],
      totalCount: null
    };
  },
  props: {
    initialSearch: {
      type: String
    }
  },
  computed: {
    loading: function() {
      return this.$store.getters["productSets/loading"];
    }
  },
  watch: {
    search: {
      handler: _.debounce(function() {
        this.getProducts();
      }, 400)
    }
  },
  mounted: function() {
    if (this.search) this.getProducts(); //method1 will execute at pageload
  },
  methods: {
    getProducts() {
      this.products = [];
      this.$store
        .dispatch("productSets/index", {
          pagination: this.pagination,
          search: this.search,
          filters: this.filters
        })
        .then(data => this.dispatchData(data));
    },
    dispatchData(data) {
      this.products = data.sets.data;
      this.totalCount = data._meta.totalCount;
    },
    selectSet(item) {
      this.products = [];
      item;
      this.$emit("select-set", item);
    }
  }
};
</script>
